import { useState } from 'react';
import AnimatedNumber from '../components/AnimatedNumber.jsx';
import Icon from '../components/Icon.jsx';
import './SchoolsSlide.css';

const studentDots = Array.from({ length: 28 }, (_, index) => index);
const schoolTiles = Array.from({ length: 6 }, (_, index) => index);

const steps = [
  {
    id: 'schools',
    icon: 'school',
    placement: 'upper',
    content: 'schools within a 10 km',
  },
  {
    id: 'students',
    icon: 'people',
    placement: 'lower',
    content: 'students',
  },
  {
    id: 'awareness',
    icon: 'people',
    placement: 'upper',
    content: 'Awareness campaigns for parents, teachers and students',
  },
  {
    id: 'screening',
    icon: 'ear',
    placement: 'lower',
    content: 'Hearing screening',
  },
];

function StepVisual({ id, active }) {
  if (id === 'schools') {
    return (
      <div className="schools-journey-visual schools-journey-visual-schools" aria-hidden="true">
        <div className="schools-journey-school-tiles">
          {schoolTiles.map((item) => (
            <span
              key={item}
              style={{
                '--tile-index': item,
                '--tile-x': item % 3,
                '--tile-y': Math.floor(item / 3),
              }}
            >
              <Icon name="school" />
            </span>
          ))}
        </div>
        <AnimatedNumber value={14} active={active} className="schools-journey-number" />
      </div>
    );
  }

  if (id === 'students') {
    return (
      <div className="schools-journey-visual schools-journey-visual-students" aria-hidden="true">
        <div className="schools-journey-student-cloud">
          {studentDots.map((item) => (
            <i key={item} style={{ '--dot-index': item }} />
          ))}
        </div>
        <AnimatedNumber value={13000} active={active} className="schools-journey-number" />
      </div>
    );
  }

  if (id === 'awareness') {
    return (
      <div className="schools-journey-visual schools-journey-visual-awareness" aria-hidden="true">
        <span className="schools-awareness-orbit orbit-a" />
        <span className="schools-awareness-orbit orbit-b" />
        <span className="schools-awareness-orbit orbit-c" />
        <span className="schools-awareness-icon"><Icon name="people" /></span>
      </div>
    );
  }

  return (
    <div className="schools-journey-visual schools-journey-visual-screening" aria-hidden="true">
      <span className="schools-screening-ring ring-a" />
      <span className="schools-screening-ring ring-b" />
      <span className="schools-screening-ring ring-c" />
      <span className="schools-screening-icon"><Icon name="ear" /></span>
    </div>
  );
}

export default function SchoolsSlide({ active }) {
  const [activeStep, setActiveStep] = useState(0);
  const progressRatio = activeStep / (steps.length - 1);
  const progressPosition = `${progressRatio * 100}%`;

  return (
    <section className={`slide-content schools-slide schools-journey${active ? ' is-active' : ''}`}>
      <header className="schools-journey-heading reveal-stack">
        <div className="eyebrow dark">
          <Icon name="school" />
          Schools screening
        </div>
        <h2>
          Schools <em>screening</em>
        </h2>
      </header>

      <div
        className="schools-journey-stage"
        style={{
          '--journey-progress': progressRatio,
          '--journey-position': progressPosition,
        }}
      >
        <div className="schools-journey-grid" aria-hidden="true" />
        <div className="schools-journey-glow glow-left" aria-hidden="true" />
        <div className="schools-journey-glow glow-right" aria-hidden="true" />
        <div className="schools-journey-scene" aria-hidden="true">09</div>

        <div className="schools-journey-track" aria-hidden="true">
          <span className="schools-journey-track-base" />
          <span className="schools-journey-track-progress" />
          <span className="schools-journey-track-pulse" />
        </div>

        <div className="schools-journey-steps">
          {steps.map((step, index) => {
            const isActive = index === activeStep;
            const isComplete = index < activeStep;

            return (
              <button
                type="button"
                key={step.id}
                className={`schools-journey-step is-${step.placement}${isActive ? ' is-active' : ''}${isComplete ? ' is-complete' : ''}`}
                onMouseEnter={() => setActiveStep(index)}
                onFocus={() => setActiveStep(index)}
                onClick={() => setActiveStep(index)}
                aria-pressed={isActive}
                aria-label={step.content}
              >
                <span className="schools-journey-card">
                  <StepVisual id={step.id} active={active} />
                  <span className="schools-journey-copy">{step.content}</span>
                  <span className="schools-journey-card-line" aria-hidden="true" />
                </span>

                <span className="schools-journey-node" aria-hidden="true">
                  <span><Icon name={step.icon} /></span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
